<template>
  <v-row>
    <v-col>
      <div v-if="showCard">
        <CardsView
          :items="salariesConcepts"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-if="!showCard">
        <TableWithSearch
          :items="salariesConcepts"
          :title="title"
          :headers="allHeaders"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-dialog
        v-model="open"
        :fullscreen="mode === $tc('rulesDistribution.editDistribution')"
        :max-width="maxWidth[0]"
        hide-overlay
        persistent
        @keydown.esc="reset(false)"
      >
        <FormDataTable
          :items="dataInputs"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :itemsSelect="dataSelects"
          :itemsHours="dataInputsHours"
          :key="formKey"
          @force-form="forceForm"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
        :maxWidth="maxWidth[1]"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import concepts from "@/store/conceptos/concepts";
import salariesConcepts from "@/store/conceptosDeSueldos/salaryConcepts";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import FormDataTable from "./Form/FormDataTable.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import rulesLiquidation from "@/store/modelosDeLiquidacion/rulesLiquidation";
import costCenters from "@/store/centrosDeCosto/costCenters";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    FormDataTable,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  props: {
    showCard: Boolean,
  },
  data() {
    return {
      title: "",
      titleTable: "reglasDeDistribucion_y_Relaciones",
      titleDelete: this.$tc("rulesDistribution.toDistribution"),
      isLoading: true,
      maxWidth: ["600px", "500px", "400px", "300"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      itemId: null,
      oldItems: null,
      dataInputs: [
        {
          name: "name",
          label: this.$tc("rulesDistribution.nameRule"),
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$tc("costCenter.rulesDataName50chart"),
          ],
        },
        {
          name: "description",
          label: this.$tc("rulesDistribution.description"),
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$tc("costCenter.rulesDataName50chart"),
          ],
        },
      ],
      dataInputsHours: [
        {
          name: "umbral",
          label: "Ingresa cantidad de horas (hh:mm)",
          data: "",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
      ],
      headers: {
        reglasDeDistribucion: [
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
        detalles: [
          {
            text: "Orden",
            value: "orden",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Maximo",
            value: "maximo",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Resto",
            value: "restoTable",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
      },
      reglasDeDistribucion: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      formKey: 0,
    };
  },

  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable.dispatch("getColumsTableName", nameTable).then(() => {
      if (configTable.state.colums.length === 0 || Object.values(this.allColums).reduce((sum, array) => sum + array.length, 0) !== 
             Object.values(this.headers).reduce((sum, array) => sum + array.length, 0)) {
        this.saveConfigColumns();
      }
    });

    try {
      await Promise.all([
        rulesLiquidation.dispatch("getRulesLiquidations"),
        concepts.dispatch("getConcepts"),
        costCenters.dispatch("getCostCenters"),
      ]);
      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },
  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums.reglasDeDistribucion)
        ? configTable.state.colums.reglasDeDistribucion
        : [];
    },
    allColums() {
      return configTable.state.colums;
    },
    salariesConcepts() {
      return rulesLiquidation.state.rulesLiquidations;
    },
    padding() {
      return rulesLiquidation.state.paddingNav;
    },
    concepts() {
      return concepts.state.concepts;
    },
    costCenters() {
      return costCenters.state.costCenters;
    },
    dataSelects() {
      return [
        {
          name: "conceptId",
          label: this.$tc("rulesDistribution.concept"),
          data: [],
          items: this.concepts,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
        {
          name: "csCostId",
          label: this.$tc("rulesDistribution.csCosts"),
          data: [],
          items: this.costCenters,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },
    mode: {
      get() {
        return rulesLiquidation.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return rulesLiquidation.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return rulesLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    forceForm() {
      this.formKey++;
    },
    async refreshItems() {
      await rulesLiquidation.dispatch("getRulesLiquidations");
    },
    updateHeaders(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        reglasDeDistribucion: headers,
      };
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || Object.values(this.allColums).reduce((sum, array) => sum + array.length, 0) !== 
        Object.values(this.headers).reduce((sum, array) => sum + array.length, 0) || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    add(form) {
      let payload = form;

      if (payload.umbral) {
        payload.umbral = this.convertToMinutes(payload.umbral);
      }
      rulesLiquidation.commit("setNew", payload);
      rulesLiquidation
        .dispatch("add")
        .then(() => {
          rulesLiquidation.dispatch("getRulesLiquidations");
          this.alert = true;
          this.textAlert = this.$tc("rulesDistribution.addDistributionSuccess");
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#ff8d58";
        });
      this.reset(false);
    },

    async edit(form) {
      const payload = form;
      payload.reglaliqid = this.itemId;
      if (payload.umbral) {
        payload.umbral = this.convertToMinutes(payload.umbral);
      }
      await rulesLiquidation.commit("setEdit", payload);
      await rulesLiquidation
        .dispatch("edit")
        .then(() => {
          rulesLiquidation.dispatch("getRulesLiquidations");
          this.alert = true;
          this.textAlert = this.$tc("rulesLiquidation.editDistributionSuccess");
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#ff8d58";
        });
      this.reset(false);
    },

    buildPayloadEdit(formData) {
      const liqModelos = formData.modelsLiquidation
        ? formData.modelsLiquidation.split(",").map(Number)
        : undefined;

      const payload = {
        nombre: formData.name,
      };

      if (liqModelos) {
        payload.liqModelos = liqModelos;
      }

      return payload;
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.add(items);
          break;
        case "edit":
          this.edit(items);
          break;
        default:
          break;
      }
    },

    reset(value) {
      rulesLiquidation.commit("setOpen", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
      });
      this.dataInputsHours.forEach((item) => {
        item.data = "";
      });
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
    },

    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          rulesLiquidation.commit(
            "setMode",
            this.$tc("rulesDistribution.addDistribution")
          );
          rulesLiquidation.commit("setOpen", true);
          break;
        case "edit":
          this.oldItems = item;
          this.itemId = item.id;
          await rulesLiquidation.dispatch("getRulesLiquidationId", this.itemId);
          rulesLiquidation.commit(
            "setMode",
            this.$tc("rulesDistribution.editDistribution")
          );
          await this.setEdit(rulesLiquidation.state.editRelation);
          this.formKey++;
          break;
        case "delete":
          rulesLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = item.id;
          break;

        default:
          break;
      }
    },
    async setEdit(item) {
      this.dataInputs[0].data = item.nombre;
      this.dataInputs[1].data = item.descrip;
      let hour = this.convertToHours(item.umbral);
      this.dataInputsHours[0].data = hour;
      await rulesLiquidation.commit("setEdit", item);
      this.dataSelects[0].data = item.conceptoId;
      this.dataSelects[1].data = item.csCostoId;
      rulesLiquidation.commit("setOpen", true);
    },

    convertToMinutes(value, dayValue) {
      const [hours, minutes] = value.split(":");
      const hoursInt = parseInt(hours, 10);
      const minutesInt = parseInt(minutes, 10);
      let totalMinutes = hoursInt * 60 + minutesInt;
      if (dayValue === "0") {
        totalMinutes -= 1440;
      } else if (dayValue === "2") {
        totalMinutes += 1440;
      }
      return totalMinutes;
    },
    convertToHours(minutos) {
      if (typeof minutos !== "number" || minutos < 0) {
        return "Invalido";
      }

      const horas = Math.floor(minutos / 60);
      const minutosRestantes = minutos % 60;

      const horasFormateadas = horas.toString().padStart(2, "0");
      const minutosFormateados = minutosRestantes.toString().padStart(2, "0");

      return horasFormateadas + ":" + minutosFormateados;
    },

    deleteItem() {
      rulesLiquidation.commit("setItemDelete", this.itemToDelete);
      rulesLiquidation
        .dispatch("delete")
        .then(() => {
          rulesLiquidation.dispatch("getRulesLiquidations");
          this.openDelete = false;
          rulesLiquidation.commit("setOpenDelete", false);
          this.alert = true;
          this.textAlert = this.$tc(
            "rulesDistribution.deleteDistributionSuccess"
          );
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#ff8d58";
        });
    },

    cancelDelete() {
      this.openDelete = false;
      rulesLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>
